import { render, staticRenderFns } from "./banque_list.vue?vue&type=template&id=7608fa90&"
import script from "./banque_list.vue?vue&type=script&lang=js&"
export * from "./banque_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports